/**
  * 商城 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
//  const api = '/home/'
 const api = '/c-api/'
 
 const index = {
    // 发票列表
    invoiceList (params) {
        return axios.post('/miniprogram/invoice/list', qs.stringify(params))
    },
    // 添加发票
    addInvoice (params) {
        return axios.post('/miniprogram/invoice/add', qs.stringify(params))
    },
    // 发票详情
    invoiceDetail (params) {
        return axios.get('/miniprogram/invoice/detail', { params: params })
    },
    // // 编辑发票
    // editInvoice (params) {
    //     return axios.post('/miniprogram/invoice/editinvoice', qs.stringify(params))
    // },
    // 删除发票
    deleteInvoice (params) {
        return axios.post('/miniprogram/invoice/del', qs.stringify(params))
    },
    // 区域信息
    areaList (params) {
        return axios.get('/home/area/list', { params: params })
    },
 }
 
 // 导出接口
 export default index